// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bilan-projet-title {
  font-size: 24px;
  font-weight: bold;
  padding-left: 0px;
  padding-top: 25px;
  margin-bottom: 15px;
}

.bilan-project-step {
  border-bottom: 1px solid lightgray;
  padding-bottom: 15px;
  margin-bottom: 10px;
}

.bilan-project-step-nombre {
  background-color: #3cb599 !important;
  color: white;
  border: none;
  margin: 0px;
  margin-right: 10px;
  padding: 7px;
  padding-left: 12px;
  padding-right: 12px;
  font-size: 0.7em;
  align-items: center;
  border-radius: 50%;
  justify-content: center;
}

.last-step {
  background-color: #3cb599 !important;
  color: white;
  border: none;
  margin: 0px;
  margin-right: 10px;
  padding: 7px;
  padding-left: 12px;
  padding-right: 12px;
  font-size: 1em;
  align-items: center;
  border-radius: 50%;
  justify-content: center;
}

.prix-m2-summary {
  font-size: 10px;
  padding-top: 5px;
}

.projet-summary {
  font-size: 0.875rem;
}

.projet-summary-vente {
  padding-left: 5px;
  font-weight: bold;
  font-size: 14px;
  color: #3cb599;
}

.card-project-kpi {
  width: 100%;
  margin-bottom: 25px;
}

.card-project-header {
  border-bottom: none !important;
  font-size: 18px;
  color: gray;
}

.frais-agence {
  font-size: 16px;
  color: gray;
}

.kpi {
  text-align: center;
  font-weight: bold;
  color: #3cb599;
  font-size: 24px;
  padding-top: 0 !important;
}

.cout-total-projet {
  color: blue;
}
.total-depenses {
  color: red;
}

.montant-a-financer {
  color: orange;
}

.montant-apport {
  color: black;
}

.montant-tva {
  color: green;
}
.no-padding {
  padding: 0 !important;
}

.marge-nette {
  color: #3cb599;
}

.tva-collectee-total {
  font-weight: lighter;
  font-size: 18px;
  color: gray;
}

.tva-collectee {
  color: grey;
  font-size: 16px;
  width: 100%;
}

.tva-collectee-percent {
  width: 50%;

  display: inline-block;
}
.tva-collectee-value {
  width: 50%;

  display: inline-block;
}

.calcul-marge-projet-table {
  border: none;
  margin-top: 20px;
  width: 100%;
  color: gray;
  font-weight: 400;
}
.calcul-marge-projet-row {
  border: none;
}
.calcul-marge-projet-category {
  text-align: left;
  font-size: 14px;
  border: none;
  padding: 3px 3px 3px 3px !important;
  font-weight: 400;
  color: rgb(128, 128, 128);
}

.fs-14 {
  font-size: 14px !important;
}

.show-details {
  color: #3cb599;
  font-size: 12px;
  text-decoration: underline;
  cursor: pointer;
}

.calcul-marge-projet-subtotal-category {
  text-align: left;
  font-size: 18px;
  border: none;
  padding: 3px 3px 3px 3px !important;
  font-weight: 800;
  color: black;
}

.calcul-marge-projet-subtotal-amount {
  text-align: left;
  font-size: 18px;
  border: none;
  padding: 3px 3px 3px 3px !important;
  font-weight: 800 !important;
  color: black;
}

.red {
  color: red !important;
}

.blue {
  color: blue !important;
}

.my-green {
  color: #3cb599 !important;
}

.white {
  color: white !important;
}

.calcul-marge-projet-edit {
  text-align: right;
  padding: 3px 3px 3px 3px !important;
  border: none;
  color: rgb(128, 128, 128);
  font-weight: 400;
}

.calcul-marge-projet-amount {
  text-align: right;
  color: rgb(128, 128, 128);
  font-size: 16px;
  font-weight: bold;
  padding: 3px 3px 3px 3px !important;
  border: none;
  font-weight: 400;
}

.bold {
  font-weight: 800;
}

.cell-debug {
  border: 1px solid red;
}

.projet-summary-sub {
  font-size: 12px;
}

.row-calcul-marge-projet-subtotal-category {
  background-color: lightgrey;
}

.row-calcul-marge-projet-subtotal-subcategory {
  background-color: rgb(233, 233, 233);
}

.row-calcul-marge-projet-marge-nette {
  background-color: #3cb599;
}

.cell-calcul-marge-projet-subtotal-category {
  padding: 10px !important;
}

.horizontal-slider {
  width: 100%;
  max-width: 500px;
  height: 100vh;
  margin: auto;
}
.example-thumb {
  cursor: pointer;
  position: absolute;
  z-index: 100;
  background: #ffffff;
  border: 5px solid #3774ff;
  border-radius: 100%;
  display: block;
  box-shadow: 0 0 2px 0 rgb(0 0 0 / 44%);
}
.example-thumb.active {
  background-color: grey;
}
.example-track {
  position: relative;
  background: #ddd;
}
.example-track.example-track-0 {
  background: #83a9ff;
}
.horizontal-slider .example-track {
  top: 20px;
  height: 4px;
}
.horizontal-slider .example-thumb {
  top: 12px;
  width: 10px;
  outline: none;
  height: 10px;
  line-height: 38px;
}
.green.card-body {
  background-color: #3cb599;
  color: #ffffff;
  font-weight: bold;
}

.gray.card-body {
  background-color: gray;
  color: #ffffff;
  font-weight: bold;
}

.table > :not(caption) > * > * {
  border-bottom-width: 0 !important;
}

.type-bien {
  text-transform: uppercase;
  font-weight: bold;
}

.table-header {
  color: black;
  font-size: 16px;
  font-weight: bold;
}

.hide-details {
  font-size: 10px;
  font-weight: normal;
  color: #3cb599;
  text-decoration: underline;
}

.show {
  display: block;
}

.hide {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ProjectPage.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,WAAW;AACb;;AAEA;EACE,UAAU;;EAEV,qBAAqB;AACvB;AACA;EACE,UAAU;;EAEV,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,mCAAmC;EACnC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,mCAAmC;EACnC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,mCAAmC;EACnC,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,mCAAmC;EACnC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,sCAAsC;AACxC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,WAAW;AACb;AACA;EACE,SAAS;EACT,WAAW;EACX,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".bilan-projet-title {\r\n  font-size: 24px;\r\n  font-weight: bold;\r\n  padding-left: 0px;\r\n  padding-top: 25px;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.bilan-project-step {\r\n  border-bottom: 1px solid lightgray;\r\n  padding-bottom: 15px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.bilan-project-step-nombre {\r\n  background-color: #3cb599 !important;\r\n  color: white;\r\n  border: none;\r\n  margin: 0px;\r\n  margin-right: 10px;\r\n  padding: 7px;\r\n  padding-left: 12px;\r\n  padding-right: 12px;\r\n  font-size: 0.7em;\r\n  align-items: center;\r\n  border-radius: 50%;\r\n  justify-content: center;\r\n}\r\n\r\n.last-step {\r\n  background-color: #3cb599 !important;\r\n  color: white;\r\n  border: none;\r\n  margin: 0px;\r\n  margin-right: 10px;\r\n  padding: 7px;\r\n  padding-left: 12px;\r\n  padding-right: 12px;\r\n  font-size: 1em;\r\n  align-items: center;\r\n  border-radius: 50%;\r\n  justify-content: center;\r\n}\r\n\r\n.prix-m2-summary {\r\n  font-size: 10px;\r\n  padding-top: 5px;\r\n}\r\n\r\n.projet-summary {\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.projet-summary-vente {\r\n  padding-left: 5px;\r\n  font-weight: bold;\r\n  font-size: 14px;\r\n  color: #3cb599;\r\n}\r\n\r\n.card-project-kpi {\r\n  width: 100%;\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.card-project-header {\r\n  border-bottom: none !important;\r\n  font-size: 18px;\r\n  color: gray;\r\n}\r\n\r\n.frais-agence {\r\n  font-size: 16px;\r\n  color: gray;\r\n}\r\n\r\n.kpi {\r\n  text-align: center;\r\n  font-weight: bold;\r\n  color: #3cb599;\r\n  font-size: 24px;\r\n  padding-top: 0 !important;\r\n}\r\n\r\n.cout-total-projet {\r\n  color: blue;\r\n}\r\n.total-depenses {\r\n  color: red;\r\n}\r\n\r\n.montant-a-financer {\r\n  color: orange;\r\n}\r\n\r\n.montant-apport {\r\n  color: black;\r\n}\r\n\r\n.montant-tva {\r\n  color: green;\r\n}\r\n.no-padding {\r\n  padding: 0 !important;\r\n}\r\n\r\n.marge-nette {\r\n  color: #3cb599;\r\n}\r\n\r\n.tva-collectee-total {\r\n  font-weight: lighter;\r\n  font-size: 18px;\r\n  color: gray;\r\n}\r\n\r\n.tva-collectee {\r\n  color: grey;\r\n  font-size: 16px;\r\n  width: 100%;\r\n}\r\n\r\n.tva-collectee-percent {\r\n  width: 50%;\r\n\r\n  display: inline-block;\r\n}\r\n.tva-collectee-value {\r\n  width: 50%;\r\n\r\n  display: inline-block;\r\n}\r\n\r\n.calcul-marge-projet-table {\r\n  border: none;\r\n  margin-top: 20px;\r\n  width: 100%;\r\n  color: gray;\r\n  font-weight: 400;\r\n}\r\n.calcul-marge-projet-row {\r\n  border: none;\r\n}\r\n.calcul-marge-projet-category {\r\n  text-align: left;\r\n  font-size: 14px;\r\n  border: none;\r\n  padding: 3px 3px 3px 3px !important;\r\n  font-weight: 400;\r\n  color: rgb(128, 128, 128);\r\n}\r\n\r\n.fs-14 {\r\n  font-size: 14px !important;\r\n}\r\n\r\n.show-details {\r\n  color: #3cb599;\r\n  font-size: 12px;\r\n  text-decoration: underline;\r\n  cursor: pointer;\r\n}\r\n\r\n.calcul-marge-projet-subtotal-category {\r\n  text-align: left;\r\n  font-size: 18px;\r\n  border: none;\r\n  padding: 3px 3px 3px 3px !important;\r\n  font-weight: 800;\r\n  color: black;\r\n}\r\n\r\n.calcul-marge-projet-subtotal-amount {\r\n  text-align: left;\r\n  font-size: 18px;\r\n  border: none;\r\n  padding: 3px 3px 3px 3px !important;\r\n  font-weight: 800 !important;\r\n  color: black;\r\n}\r\n\r\n.red {\r\n  color: red !important;\r\n}\r\n\r\n.blue {\r\n  color: blue !important;\r\n}\r\n\r\n.my-green {\r\n  color: #3cb599 !important;\r\n}\r\n\r\n.white {\r\n  color: white !important;\r\n}\r\n\r\n.calcul-marge-projet-edit {\r\n  text-align: right;\r\n  padding: 3px 3px 3px 3px !important;\r\n  border: none;\r\n  color: rgb(128, 128, 128);\r\n  font-weight: 400;\r\n}\r\n\r\n.calcul-marge-projet-amount {\r\n  text-align: right;\r\n  color: rgb(128, 128, 128);\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  padding: 3px 3px 3px 3px !important;\r\n  border: none;\r\n  font-weight: 400;\r\n}\r\n\r\n.bold {\r\n  font-weight: 800;\r\n}\r\n\r\n.cell-debug {\r\n  border: 1px solid red;\r\n}\r\n\r\n.projet-summary-sub {\r\n  font-size: 12px;\r\n}\r\n\r\n.row-calcul-marge-projet-subtotal-category {\r\n  background-color: lightgrey;\r\n}\r\n\r\n.row-calcul-marge-projet-subtotal-subcategory {\r\n  background-color: rgb(233, 233, 233);\r\n}\r\n\r\n.row-calcul-marge-projet-marge-nette {\r\n  background-color: #3cb599;\r\n}\r\n\r\n.cell-calcul-marge-projet-subtotal-category {\r\n  padding: 10px !important;\r\n}\r\n\r\n.horizontal-slider {\r\n  width: 100%;\r\n  max-width: 500px;\r\n  height: 100vh;\r\n  margin: auto;\r\n}\r\n.example-thumb {\r\n  cursor: pointer;\r\n  position: absolute;\r\n  z-index: 100;\r\n  background: #ffffff;\r\n  border: 5px solid #3774ff;\r\n  border-radius: 100%;\r\n  display: block;\r\n  box-shadow: 0 0 2px 0 rgb(0 0 0 / 44%);\r\n}\r\n.example-thumb.active {\r\n  background-color: grey;\r\n}\r\n.example-track {\r\n  position: relative;\r\n  background: #ddd;\r\n}\r\n.example-track.example-track-0 {\r\n  background: #83a9ff;\r\n}\r\n.horizontal-slider .example-track {\r\n  top: 20px;\r\n  height: 4px;\r\n}\r\n.horizontal-slider .example-thumb {\r\n  top: 12px;\r\n  width: 10px;\r\n  outline: none;\r\n  height: 10px;\r\n  line-height: 38px;\r\n}\r\n.green.card-body {\r\n  background-color: #3cb599;\r\n  color: #ffffff;\r\n  font-weight: bold;\r\n}\r\n\r\n.gray.card-body {\r\n  background-color: gray;\r\n  color: #ffffff;\r\n  font-weight: bold;\r\n}\r\n\r\n.table > :not(caption) > * > * {\r\n  border-bottom-width: 0 !important;\r\n}\r\n\r\n.type-bien {\r\n  text-transform: uppercase;\r\n  font-weight: bold;\r\n}\r\n\r\n.table-header {\r\n  color: black;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n}\r\n\r\n.hide-details {\r\n  font-size: 10px;\r\n  font-weight: normal;\r\n  color: #3cb599;\r\n  text-decoration: underline;\r\n}\r\n\r\n.show {\r\n  display: block;\r\n}\r\n\r\n.hide {\r\n  display: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
